import { useEffect } from "react";
import { messaging, getToken } from "./firebase";
import useToken from "../../hooks/useToken";

const PushNotificationButton = () => {
  const { setToken } = useToken();
  const requestPermission = async () => {
    try {
      const permission = await Notification.requestPermission();
      if (permission === "granted") {
        const token = await getToken(messaging, {
          vapidKey: process.env.REACT_APP_VAPID,
        });

        setToken(token);
        // Send this token to your backend to send push notifications
      } else {
        console.error("Permission denied");
      }
    } catch (error) {
      console.error("Error getting permission:", error);
    }
  };

  useEffect(() => {
    requestPermission(); // eslint-disable-next-line
  }, []);

  return <div></div>;
};

export default PushNotificationButton;
